const md5 = require('js-md5');

/**
 * è·åéæºæ è¯ç¬¦
 *
 */
export function getIdentityCode(): string {
  // å½åæ¶é´æ³å éæºæ°
  return md5(new Date().getTime() + randomChar(5));
}

/**
 * è·åéæºé¿åº¦å­ç¬¦ä¸²
 *
 */
export function randomChar(len: number): string {
  len = len || 32;
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****é»è®¤å»æäºå®¹ææ··æ·çå­ç¬¦oOLl,9gq,Vv,Uu,I1****/
  const maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
